import useBillTypeContext from './useStockBillTypeContext'
import { useState, useRef } from 'react'
const defaultPageData = {
  result: [],
  pageCount: 0,
  recordCount: 0,
  pageIndex: 1,
  pageSize: 10
}
export default function useGetBillProductList() {
  const { baseQueryModule } = useBillTypeContext()
  const [pageData, setPageData] = useState(defaultPageData)
  const [loading, setLoading] = useState(false)
  const billNo = useRef(null)
  const getList = async params => {
    setLoading(true)
    if (params.billNo) billNo.current = params.billNo
    try {
      const listData = await baseQueryModule.getStockProductList({
        no: billNo.current,
        pageIndex: params.pageIndex || pageData.pageIndex,
        pageSize: params.pageSize || pageData.pageSize
      })
      setLoading(false)
      listData && setPageData(listData)
    } catch (error) {
      if (params.billNo) setPageData(defaultPageData)
      setLoading(false)
    }
  }
  return {
    pageData,
    loading,
    getList
  }
}
